// src/hooks/useIsMobile.js
// True when the window is phone-width. Nothing is asked of the user - it just
// reads the screen width (and updates on rotate/resize), so screens can swap
// to a stacked layout on narrow screens while desktop stays exactly as it was.
import { useState, useEffect } from 'react';

export const MOBILE_BREAKPOINT = 640;

const query = `(max-width: ${MOBILE_BREAKPOINT}px)`;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
};

export default useIsMobile;
